<template>
    <div v-if="appParams && appParams.staticTranslations">
        <h2 class="text-center">
            {{
                appParams.staticTranslations[
                    "products_2d.technical_informations"
                ]
            }}
        </h2>
        <hero-cards :cards="heroCards"></hero-cards>

        <section id="itb-prefabricated-2d">
            <div class="container">
                <div class="row">
                    <div class="col-12 col-md-6">
                        <div
                            class="itb-top-image itb-first"
                            v-lazy:background-image="
                                '/images/articles/prefabricated-2d-top-left.webp'
                            "
                        ></div>
                    </div>
                    <div
                        id="itb-prefabricated-2d-lable"
                        v-lazy:background-image="
                            '/images/' +
                            languageDependantImageSubFolder +
                            '/prefabricated-2d-top-label.webp'
                        "
                    ></div>
                    <div
                        class="col-12 itb-top-badge"
                        v-lazy-container="{ selector: '.itb-lazy' }"
                    >
                        <img
                            :data-src="
                                '/images/' +
                                languageDependantImageSubFolder +
                                '/prefabricated-2d-top-badge.webp'
                            "
                            alt="Img"
                            class="itb-lazy"
                        />
                    </div>
                    <div class="col-12 col-md-6">
                        <div
                            class="itb-top-image"
                            v-lazy:background-image="
                                '/images/articles/prefabricated-2d-top-right.webp'
                            "
                        ></div>
                    </div>
                </div>
                <div class="row">
                    <div class="col-12">
                        <div class="itb-middle-text itb-bg-blue">
                            <h2>
                                {{
                                    appParams.staticTranslations[
                                        "products_2d.prefabricated_2d_title"
                                    ]
                                }}
                            </h2>
                            <p class="m-0">
                                {{
                                    appParams.staticTranslations[
                                        "products_2d.prefabricated_2d_text"
                                    ]
                                }}
                            </p>
                        </div>
                    </div>
                </div>
                <div class="row">
                    <div class="col-12 col-md-6">
                        <div
                            class="itb-bottom-image"
                            v-lazy:background-image="
                                '/images/' +
                                languageDependantImageSubFolder +
                                '/prefabricated-2d-bottom-left.webp'
                            "
                            style="background-position: right"
                        ></div>
                    </div>
                    <div class="col-12 col-md-6">
                        <div
                            class="itb-bottom-image itb-last"
                            v-lazy:background-image="
                                '/images/' +
                                languageDependantImageSubFolder +
                                '/prefabricated-2d-bottom-right.webp'
                            "
                            style="background-position: left"
                        ></div>
                    </div>
                </div>
            </div>
        </section>

        <h2 class="text-center">
            {{ appParams.staticTranslations["products_2d.instalation_videos"] }}
        </h2>
        <div class="container">
            <div class="d-flex justify-content-center align-items-center">
                <p
                    class="mb-0 itb-youtube-warning"
                    :class="{
                        'itb-youtube-warning-highlight': isYoutubeHighlighted,
                    }"
                    ref="youtubeWarning"
                >
                    {{
                        appParams.staticTranslations["general.youtube_warning"]
                    }}
                    {{
                        appParams.staticTranslations[
                            "general.see_youtube_policy"
                        ]
                    }}
                    <a
                        href="https://policies.google.com/privacy"
                        target="_blank"
                        >{{
                            appParams.staticTranslations[
                                "general.youtube_policy"
                            ]
                        }}.</a
                    >
                </p>
                <button
                    class="btn btn-secondary ml-2"
                    :disabled="youtubePermit"
                    @click="youtubePermit = true"
                >
                    {{ appParams.staticTranslations["cookies.accept"] }}
                </button>
            </div>
        </div>
        <section style="margin-top: 3rem; margin-bottom: 4rem">
            <div class="container">
                <div class="row">
                    <div class="col-12 col-md-6 itb-youtube-video">
                        <div
                            v-if="!youtubePermit"
                            class="itb-youtube-image d-flex justify-content-center align-items-center"
                            @click="warningHighlight"
                        >
                            <img
                                src="/images/youtube-logo.png"
                                alt="youtube-logo"
                            />
                        </div>
                        <iframe
                            :src="pageParams.page_first_video_url"
                            frameborder="0"
                            allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture"
                            allowfullscreen
                            v-else
                        ></iframe>
                    </div>
                    <div class="col-12 col-md-6 itb-youtube-video">
                        <div
                            v-if="!youtubePermit"
                            class="itb-youtube-image d-flex justify-content-center align-items-center"
                            @click="warningHighlight"
                        >
                            <img
                                src="/images/youtube-logo.png"
                                alt="youtube-logo"
                            />
                        </div>
                        <iframe
                            :src="pageParams.page_second_video_url"
                            frameborder="0"
                            allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture"
                            allowfullscreen
                            v-else
                        ></iframe>
                    </div>
                </div>
            </div>
        </section>

        <h2
            class="text-center itb-horizontal-border pt-5"
            id="itb-h2-inspirations"
            ref="realizations"
            v-if="realizations && realizations.length > 0"
        >
            {{ appParams.staticTranslations["products_2d.2d_inspirations"] }}
        </h2>
        <section
            class="itb-references-alike-set"
            style="margin-top: 3.7rem"
            v-if="realizations && realizations.length > 0"
        >
            <div class="container">
                <div class="row">
                    <div class="col-12 col-md-12">
                        <div class="row">
                            <div
                                class="col-12 col-md-4"
                                v-for="(realization, index) in realizations"
                            >
                                <div
                                    class="card w-100 itb-margin-bottom itb-lazy-loading-bg"
                                    role="button"
                                    @click="
                                        viewRealization(
                                            realization.id,
                                            realization.alias
                                        )
                                    "
                                    v-lazy:background-image="
                                        realization.image
                                            ? '/uploads/' + realization.image
                                            : null
                                    "
                                >
                                    <div class="card-body d-flex p-0">
                                        <div
                                            class="itb-text align-self-end w-100"
                                        >
                                            <h3 class="mb-0">
                                                {{ realization.name }}
                                            </h3>
                                            <p class="itb-h3-subtitle">
                                                {{ realization.location }}
                                            </p>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </section>

        <section class="itb-hero-cards" id="itb-catalog-intro">
            <div class="container">
                <div class="itb-hero-card row d-flex align-content-center mx-0">
                    <div
                        v-if="isResponsive"
                        class="itb-hero-responsive-image"
                        v-lazy:background-image="
                            '/images/articles/catalog-intro-2d.webp'
                        "
                    ></div>
                    <div class="itb-fake-background">
                        <div
                            class="itb-lazy-loading-bg"
                            v-lazy:background-image="
                                !isResponsive
                                    ? '/images/articles/catalog-intro-2d.webp'
                                    : '/images/articles/blank-bg.webp'
                            "
                        ></div>
                    </div>

                    <div class="col-12 col-md-6 col-lg-4 mb-3 mb-md-0">
                        <div
                            class="itb-card itb-bg-blue h-100 d-flex align-items-center"
                        >
                            <div>
                                <h2>
                                    {{
                                        appParams.staticTranslations[
                                            "products_2d.catalog_intro_title"
                                        ]
                                    }}
                                </h2>
                                <router-link
                                    :to="'/choose-the-graphic/2D'"
                                    class="btn btn-secondary itb-btn-icon"
                                >
                                    {{
                                        appParams.staticTranslations[
                                            "graphics.show_all_products"
                                        ]
                                    }}
                                    <img
                                        src="/images/icons/4soft_icon_angle-right.svg"
                                        :alt="
                                            appParams.staticTranslations[
                                                'general.button'
                                            ] +
                                            ' ' +
                                            appParams.staticTranslations[
                                                'main_category.show_all_realizations'
                                            ]
                                        "
                                        class="itb-icon itb-angle-right-icon"
                                    />
                                </router-link>
                            </div>
                        </div>
                    </div>

                    <div class="col-12 col-md-6 col-lg-8">
                        <div class="row h-100">
                            <div
                                class="col-12 col-md-6 col-lg-4 mb-3 mb-md-0"
                                v-for="graphic in graphics"
                                :key="graphic.id"
                            >
                                <div
                                    class="card h-100 text-center"
                                    style="overflow: hidden"
                                >
                                    <div class="card-body d-flex p-0">
                                        <div class="align-self-end w-100">
                                            <img
                                                :src="
                                                    graphic.image
                                                        ? '/uploads/' +
                                                          graphic.image
                                                        : null
                                                "
                                                :alt="graphic.name"
                                            />
                                            <h3 class="itb-blue">
                                                {{ graphic.name }}
                                            </h3>
                                            <p>
                                                {{
                                                    graphic.description
                                                        | truncate(100)
                                                }}
                                            </p>
                                            <router-link
                                                :to="{
                                                    name: 'graphicDetail',
                                                    params: {
                                                        categoryAlias: '2D',
                                                        subcategoryAlias:
                                                            graphic.subcategoryAlias,
                                                        subcategory2Alias:
                                                            graphic.subcategory2Alias,
                                                        graphicAlias:
                                                            graphic.id +
                                                            '-' +
                                                            graphic.alias,
                                                    },
                                                }"
                                                class="btn btn-primary"
                                            >
                                                {{
                                                    appParams
                                                        .staticTranslations[
                                                        "graphics.detail"
                                                    ]
                                                }}
                                            </router-link>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </section>
    </div>
</template>

<script>
import { mapActions, mapGetters } from "vuex";

export default {
    data() {
        return {
            heroCards: [],
            realizations: [],
            graphics: [],
            pageParams: [],
            youtubePermit: false,
            isYoutubeHighlighted: false,
            isResponsive: false,
        };
    },

    mounted() {
        axios
            .post("/get2DProductsPage", {
                client_id: this.profile.id,
                is_logged_in: this.isLoggedIn,
            })
            .then((response) => {
                this.heroCards = response.data.heroCards;
                this.realizations = response.data.realizations;
                this.graphics = response.data.graphics;

                this.pageParams = response.data.params;
                this.pageParams["page_button_element_2"] =
                    "itb-h2-inspirations";

                this.setPageParams(this.pageParams);
            })
            .catch((error) => {
                console.log(error);
            });
    },

    created() {
        this.goToRealizations();
        this.onResize();
        window.addEventListener("resize", this.onResize);
    },

    beforeDestroy() {
        window.removeEventListener("resize", this.onResize);
    },

    computed: {
        ...mapGetters({
            appParams: "getAppParams",
            isLoggedIn: "getClientLogged",
            profile: "getClientProfile",
        }),

        languageDependantImageSubFolder() {
            var folder = "articles";
            if (this.$store.state.domainLanguage != "en") {
                folder = "articles_" + this.$store.state.domainLanguage;
            }
            return folder;
        },
    },

    filters: {
        truncate: function (data, num) {
            const reqdString = data.split("").slice(0, num).join("");
            return reqdString + "…";
        },
    },

    methods: {
        ...mapActions(["setPageParams", "setFormParams"]),

        warningHighlight() {
            this.isYoutubeHighlighted = true;
            this.$refs.youtubeWarning.scrollIntoView({
                behavior: "smooth",
                block: "center",
            });
            setTimeout(() => {
                this.isYoutubeHighlighted = false;
            }, 1500);
        },
        viewRealization(id, alias) {
            this.$router.push(
                this.$route.path + "/" + "realizations/" + id + "-" + alias
            );
        },
        goToRealizations() {
            var scrollCounter = 0;
            if (this.$route.hash == "#itb-h2-inspirations") {
                while (!!this.$refs.realizations && scrollCounter < 0) {
                    this.$refs.realizations.scrollIntoView({
                        behavior: "smooth",
                        block: "center",
                    });
                    scrollCounter = scrollCounter + 1;
                }
            }
        },
        onResize() {
            if (window.innerWidth < 992) {
                this.isResponsive = true;
            } else {
                this.isResponsive = false;
            }
        },
    },
};
</script>
